import React from "react";

const FormItemPrice = ({ value }) => {
  return (
    <div className="col-start-2 col-span-3 flex flex-col-reverse">
    <input
      type="text"
      value={value === 0 ? "" : `$${value.toFixed(2)}`}
      disabled={true}
      className="w-full p-2 border border-gray-300 rounded text-end focus:outline-none focus:ring-none cursor-not-allowed"
    />
    <span className="text-xs text-center">Price</span>
  </div>
);
};

export default FormItemPrice;
